export const COMPLAINT_STATUSES = [
    { id: 43, name: 'Создан' },
    { id: 44, name: 'Согласован' },
    { id: 45, name: 'Закрыт' },
]

export const COMPLAINT_TYPES = [
    { id: 41, name: 'Клиентские' },
    { id: 42, name: 'Сотрудники' },
]

export const COMPLAINT_TYPE_OPTIONS = [
    { id: 66, name: 'Жалоба' },
    { id: 65, name: 'Предложение' },
]

export const CLOSE_STATUS_ID = 45
